import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBackground1 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 512 512",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M245.08 457.846C248.99 462.488 253.366 467.031 258.228 471.448C304.311 511.831 362.437 513.748 408.044 478.746C456.231 436.846 460.354 376.93 434.249 333.216C438.423 330.716 442.517 327.932 446.515 324.864C524.486 257.065 487.088 142.097 392.94 124.927C386.205 124.362 379.617 124.266 373.199 124.603C374.774 71.5198 337.769 20.5037 277.534 9.5184C211.619 3.98809 159.672 43.4311 145.597 93.1749C41.2561 94.5091 -21.0358 209.537 63.4786 286.32C69.8464 291.9 76.4442 296.746 83.2072 300.861C50.9644 341.645 48.8952 401.388 99.537 447.402C144.193 486.534 200.157 489.546 245.08 457.846Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgBackground1);
export default ForwardRef;
